module.exports = __webpack_public_path__ + "img/onboarding-icon-compass.1bf33fdd.svg";